"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _AskICIS = require("./AskICIS.style");
var _uiKit = require("@icis/ui-kit");
const AskICIS = _ref => {
  let {
    isBeta
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_AskICIS.AskICISWrapper, null, isBeta && /*#__PURE__*/_react.default.createElement(_uiKit.Badge, {
    variant: "Tertiary"
  }, "BETA"), /*#__PURE__*/_react.default.createElement(_uiKit.SvgIcon, {
    icon: "askICISV2",
    testId: 'ask-ICIS-icon'
  }));
};
var _default = exports.default = AskICIS;